import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { permissionGuard } from './auth/permission.guard';
import { BOT_FLOWS, SALES_FLOWS, SCHEDULING_FLOWS } from './core/config/flows';

export const routes: Routes = [
  {
    path: 'session-required',
    loadComponent: () => import('./auth/session-required.component').then(m => m.SessionRequiredComponent)
  },
  {
    path: 'callback',
    loadComponent: () => import('./auth/callback.component').then(m => m.CallbackComponent)
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./auth/access-denied.component').then(m => m.AccessDeniedComponent)
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then(m => m.ShellComponent),
    canActivateChild: [authGuard, permissionGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        data: {
          menuLabel: 'shell.nav.dashboard'
        },
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'chats',
        data: {
          menuLabel: 'shell.nav.chats',
          requiredFlows: BOT_FLOWS
        },
        loadComponent: () => import('./chats/chats.component').then(m => m.ChatsComponent)
      },
      {
        path: 'professionals',
        data: {
          menuLabel: 'shell.nav.professionals',
          requiredPermission: ['professionals:read', 'professionals:read_admin'],
          requiredFlows: SCHEDULING_FLOWS
        },
        loadComponent: () => import('./features/professionals/professionals.page').then(m => m.ProfessionalsPage)
      },
      {
        path: 'services',
        data: {
          menuLabel: 'shell.nav.services',
          requiredPermission: ['services:read', 'services:read_admin'],
          requiredFlows: SCHEDULING_FLOWS
        },
        loadComponent: () => import('./features/services/services.page').then(m => m.ServicesPage)
      },
      {
        path: 'appointments',
        data: {
          menuLabel: 'shell.nav.appointments',
          requiredPermission: ['appointments:read'],
          requiredFlows: SCHEDULING_FLOWS
        },
        loadComponent: () => import('./features/appointments/appointments.page').then(m => m.AppointmentsPage)
      },
      {
        path: 'availability',
        data: {
          menuLabel: 'shell.nav.availability',
          requiredPermission: ['appointments:read'],
          requiredFlows: SCHEDULING_FLOWS
        },
        loadComponent: () => import('./features/availability/availability.page').then(m => m.AvailabilityPage)
      },
      {
        path: 'clients',
        data: {
          menuLabel: 'shell.nav.clients',
          requiredPermission: ['clients_bot:read', 'clients_bot:write', 'clients_bot:read_admin'],
          requiredFlows: SCHEDULING_FLOWS
        },
        loadComponent: () => import('./features/clients/clients.page').then(m => m.ClientsPage)
      },
      {
        path: 'products',
        data: {
          menuLabel: 'shell.nav.products',
          requiredPermission: ['products:read', 'products:read_admin', 'products:write'],
          requiredFlows: SALES_FLOWS
        },
        loadComponent: () => import('./features/products/products.page').then(m => m.ProductsPage)
      },
      {
        path: 'orders',
        data: {
          menuLabel: 'shell.nav.orders',
          requiredPermission: ['orders:read', 'orders:read_admin', 'orders:write'],
          requiredFlows: SALES_FLOWS
        },
        loadComponent: () => import('./features/orders/orders.page').then(m => m.OrdersPage)
      },
      {
        path: 'customers',
        data: {
          menuLabel: 'shell.nav.customers',
          requiredPermission: ['customers:read', 'customers:read_admin', 'customers:write'],
          requiredFlows: SALES_FLOWS
        },
        loadComponent: () => import('./features/customers/customers.page').then(m => m.CustomersPage)
      },
      {
        path: 'tenants',
        data: {
          menuLabel: 'shell.nav.tenants',
          // Platform-only: managers hold tenants:read (own tenant) but must not
          // reach the tenant-management page. read_admin / write are MASTER-only.
          requiredPermission: ['tenants:read_admin', 'tenants:write']
        },
        loadComponent: () => import('./features/tenants/tenants.page').then(m => m.TenantsPage)
      },
      {
        path: 'notifications',
        data: {
          menuLabel: 'shell.nav.notifications',
          requiredPermission: ['template:read'],
          requiresNotifications: true
        },
        loadComponent: () => import('./features/notifications/notifications.page').then(m => m.NotificationsPage)
      },
      {
        path: 'templates',
        data: {
          menuLabel: 'shell.nav.templates',
          requiredPermission: ['template:read'],
          requiresNotifications: true
        },
        loadComponent: () => import('./features/templates/templates.page').then(m => m.TemplatesPage)
      },
      {
        path: 'health',
        data: {
          menuLabel: 'shell.nav.health',
          // Herramienta del equipo de desarrollo, no del manager de tenant.
          // El ROL es el gate efectivo: hasPermission acepta scope O permiso y
          // la AAP concede el scope `health` a todo usuario de esta app, así
          // que el permiso por sí solo no excluye a un manager.
          requiredRole: 'ROLE_MASTER',
          requiredPermission: ['health']
        },
        loadComponent: () => import('./features/health/health.page').then(m => m.HealthPage)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];


